import React, { useEffect, useRef } from 'react'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const Hero = () => {
  const sectionRef = useRef(null)

  useEffect(() => {
    const boxes = sectionRef.current.querySelectorAll('.platform-box')
    gsap.set(boxes, { opacity: 0, y: 40 })

    ScrollTrigger.create({
      trigger: sectionRef.current,
      start: 'top 70%',
      once: true,
      onEnter: () => {
        gsap.to(boxes, {
          opacity: 1,
          y: 0,
          duration: 0.8,
          stagger: 0.2,
          ease: 'power3.out',
        })
      },
    })

    return () => ScrollTrigger.getAll().forEach(t => t.kill())
  }, [])

  return (
    <section className="training-hero-section" ref={sectionRef}>
      <div className="alignment-wrapper">
        <h1 className="heading-xl gold-text">Real World Asset Platform Overview</h1>
        <h2 className="heading-lg gold-text">Platform Structure</h2>
        <p className="hero-description">
          The Real World Asset (RWA) Platform operates through two distinct modes:
        </p>
        <div className="platform-boxes">
          <div className="platform-box">
            <h3 className="box-title">StakeHub</h3>
            <p className="box-description">
              Allows Backers to purchase <strong>RWA Tickets</strong> (Real World Asset Tickets), which are tied to royalty-tracking technology for specific campaigns.
            </p>
          </div>
          <div className="platform-box">
            <h3 className="box-title">BrandHub</h3>
            <p className="box-description">
              A restricted area where approved Founders create and manage crowdfunding campaigns, offering Tickets and rewards to Backers.
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Hero
